import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CalculatorIcon from "@mui/icons-material/Calculate";
import EmailIcon from "@mui/icons-material/Email";

const TAB_SX = {
  pointerEvents: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  backgroundColor: "#D3D3D3",
  color: "#333",
  px: 4,
  py: 2,
  borderRadius: "8px 8px 0 0",
  cursor: "pointer",
};

const ICON_BOX_SX = {
  width: 20,
  height: 20,
  backgroundColor: "#333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "2px",
};

const LABEL_SX = {
  fontSize: "1rem",
  fontWeight: 500,
  color: "#333",
  whiteSpace: "nowrap",
};

function AuthFooterTabs({ setOpenSupport, setOpenCalculator }) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        pr: 2,
        gap: 1,
        flexWrap: "wrap",
        pointerEvents: "none",
      }}
    >
      <Box onClick={() => setOpenSupport(true)} sx={{ ...TAB_SX, minWidth: "300px", maxWidth: "400px" }}>
        <Box sx={ICON_BOX_SX}>
          <EmailIcon sx={{ fontSize: 14, color: "white" }} />
        </Box>
        <Typography variant="body1" sx={LABEL_SX}>
          Contact Support
        </Typography>
      </Box>

      <Box onClick={() => setOpenCalculator(true)} sx={{ ...TAB_SX, minWidth: "320px", maxWidth: "400px" }}>
        <Box sx={ICON_BOX_SX}>
          <CalculatorIcon sx={{ fontSize: 14, color: "white" }} />
        </Box>
        <Typography variant="body1" sx={LABEL_SX}>
          Use our Bond Premium Calculator
        </Typography>
      </Box>
    </Box>
  );
}

AuthFooterTabs.propTypes = {
  setOpenSupport: PropTypes.func.isRequired,
  setOpenCalculator: PropTypes.func.isRequired,
};

export default AuthFooterTabs;
